module.exports = __webpack_public_path__ + "static/07-2a4fc777fe2ea34246e23d1620f6e1f0.jpg";